export default function StaticShim(Ctor) {
  if (Ctor.default) Ctor = Ctor.default
  return Ctor
}
